import { render, staticRenderFns } from "./LeasingPrescoreDatePickerQuestion.vue?vue&type=template&id=4cafdba5&scoped=true&"
import script from "./LeasingPrescoreDatePickerQuestion.vue?vue&type=script&lang=js&"
export * from "./LeasingPrescoreDatePickerQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cafdba5",
  null
  
)

export default component.exports